import React from 'react';
import { Card  } from 'flowbite-react'; // Added Progress and Alert

const StatCount = ({ 
    label, 
    IconComponent,
    count,
}) => {
    return (

        <Card className="transform transition-transform hover:scale-105 duration-200 ease-in-out">
                        <div className="flex items-center justify-between mb-4">
                            <h6 className="text-xl  text-gray-900 ">
                                {label}
                            </h6>
                            <IconComponent className="w-8 h-8 " />
                        </div>
                        <p className="text-xl">
                            {count.toLocaleString()}
                        </p>
                        {/* <p className="font-normal text-gray-600 dark:text-gray-400 text-sm">
                            Registered users across all services.
                        </p> */}
                    </Card>
    
    );
};

export default StatCount;